export default {
  crashCourseList: []
}
